import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageLoading from "@/components/base/PageLoading";

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-950">
      <Header />
      <main className="flex-1">
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}